<template>
  <section>
    <q-field
      :label="!hideLabel ? $t('email') : ''"
      :labelWidth="2"
      :icon="showIcon ? 'email' : undefined"
      class="q-field-force-input"
    >
      <div class="row gutter-sm">
        <!-- E-Mail-->
        <div :class="columnWidth">
          <q-field
            class="no-margin"
            :error="errors.has('email_' + id)"
            :error-label="errors.first('email_' + id)"
          >
            <q-input
              type="email"
              v-model.trim="email.email"
              v-validate.disable="'email|max:255'"
              :name="'email_' + id"
              :data-vv-as="$t('email')"
              placeholder="mail@example.com"
            />
          </q-field>
        </div>

        <!-- E-Mail Label -->
        <div :class="columnWidth" v-show="!isEmpty && label">
          <q-field
            class="no-margin"
            :error="errors.has('emailLabel_' + id)"
            :error-label="errors.first('emailLabel_' + id)"
          >
            <label-input
              v-model="email.label"
              v-validate.disable="'max:255'"
              :name="'emailLabel_' + id"
              labelList="email"
            />
          </q-field>
        </div>
      </div>
    </q-field>
  </section>
</template>

<script>
  import LabelInput from 'components/Common/Inputs/LabelInput.vue'

  export default {
    inject: ['$validator'],

    props: {
      /**
       * Used for v-model.
       */
      value: {
        type: [Object],
        required: true
      },

      /**
       * Id of the input. Required for multiple address inputs per page
       */
      id: {
        type: Number,
        default: 0
      },

      /**
       * Indicate if the label input should be visible
       */
      label: {
        type: Boolean,
        default: false
      },

      /**
       * Indicate if the label of the email line field should be visible
       */
      hideLabel: {
        type: Boolean,
        default: false
      },

      /**
       * Indicate if the field icon should be visible
       */
      showIcon: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        email: this.value
      }
    },

    computed: {
      isEmpty () {
        return !this.email.email
      },

      columnWidth () {
        return this.isEmpty || !this.label ? 'col-12' : 'col-sm-6 col-12 q-mb-sm'
      }
    },

    watch: {
      value: {
        handler: function (newEmail) {
          this.email = newEmail
        },
        deep: true
      },

      email: {
        handler: function (newEmail) {
          this.$emit('input', newEmail)
        },
        deep: true
      }
    },

    components: {
      LabelInput
    }
  }
</script>
